import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PfandrechtVersionDetailEntryMeta } from '../../../core/gb-api/model/pfandrechtVersionDetailEntryMeta';
import { TranslateNamePipe } from './translate-name.pipe';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { RechtVersionListEntry } from '../../../core/gb-api';

@Pipe({
  name: 'namenInhaberPfandrechtart',
  pure: false
})
export class NamenInhaberPfandrechtartPipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private translateName: TranslateNamePipe
  ) {
    keysToTranslate(['NAMEN_PFANDRECHT_ART', 'INHABER_PFANDRECHT_ART', 'NAMEN_PFANDRECHT_ART_PAPIER', 'INHABER_PFANDRECHT_ART_PAPIER']);
  }

  transform(value: PfandrechtVersionDetailEntryMeta | RechtVersionListEntry): any {
    if (!value) {
      return null;
   }
    const isAndrereArt : boolean = value.pfandrechtart === 'ANDEREART';
    const pfandrechtArt : string = this.getArt(isAndrereArt, value);
    if (value.namenInhaber) {
      return this.translate.instant(value.namenInhaber + '_PFANDRECHT_ART' + (!isAndrereArt ? '_PAPIER' : ''), { pfandrechtArt: pfandrechtArt });
    }
    return pfandrechtArt;
  }

  private getArt(isAndereArt: boolean, value: PfandrechtVersionDetailEntryMeta | RechtVersionListEntry): string {
    if (!isAndereArt) {
      return this.translate.instant(value.pfandrechtart);
    }
    if (value.codePfandrecht) {
      return this.translateName.transform(value.codePfandrecht.text);
    }
    return '';
  }
}
